import { render, staticRenderFns } from "./CertificationsCatalog.vue?vue&type=template&id=398ecb93&"
import script from "./CertificationsCatalog.vue?vue&type=script&lang=js&"
export * from "./CertificationsCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports